export const LOGIN_GUARD_KEY = 'bm-saui-last-login-redirect';
export const LOGIN_GUARD_WINDOW_MS = 10_000;

type LoginFunction<LoginOptions> = (options?: LoginOptions) => Promise<void>;

let loginInProgress = false;

const readLastLoginTimestamp = (): number => {
    try {
        return Number(sessionStorage.getItem(LOGIN_GUARD_KEY)) || 0;
    } catch {
        return 0;
    }
};

const writeLastLoginTimestamp = (timestamp: number) => {
    try {
        sessionStorage.setItem(LOGIN_GUARD_KEY, String(timestamp));
    } catch {
        return;
    }
};

export const isLoginInProgress = () => loginInProgress;

export const isLoginThrottled = (currentTimestamp: number): boolean => {
    const elapsedMilliseconds = currentTimestamp - readLastLoginTimestamp();
    const isInPast = elapsedMilliseconds >= 0;
    return isInPast && elapsedMilliseconds < LOGIN_GUARD_WINDOW_MS;
};

export const guardLogin =
    <LoginOptions>(login: LoginFunction<LoginOptions>): LoginFunction<LoginOptions> =>
    (options) => {
        const currentTimestamp = Date.now();
        if (loginInProgress) return Promise.resolve();
        if (isLoginThrottled(currentTimestamp)) return Promise.resolve();
        loginInProgress = true;
        writeLastLoginTimestamp(currentTimestamp);
        return login(options);
    };
